<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
    <g fill="none" fill-rule="evenodd">
        <g fill="#000">
            <g>
                <path class="fill" d="M32 2.667C48.2 2.667 61.333 15.8 61.333 32S48.2 61.333 32 61.333 2.667 48.2 2.667 32 15.8 2.667 32 2.667zM32 8C18.745 8 8 18.745 8 32s10.745 24 24 24 24-10.745 24-24S45.255 8 32 8zm12.333 21.333c.553 0 1 .448 1 1v3.334c0 .552-.447 1-1 1H19.667c-.553 0-1-.448-1-1v-3.334c0-.552.447-1 1-1h24.666z" transform="translate(-498 -1071) translate(498 1071)"/>
            </g>
        </g>
    </g>
</svg>
